import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-api-tekom-form-view',
  standalone: true,
  imports: [],
  templateUrl: './api-tekom-form-view.component.html',
  styleUrls: ['./api-tekom-form-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApiTekomFormViewComponent {

}
